export default __webpack_public_path__ + "static/media/logo-slack.d8feb9c5.svg";